<template>
  <router-view />
</template>
<script>
export default { name: 'Categories' }
</script>
